import { api } from "./api";

export const deviceService = {
  // Get all devices
  getDevices: () => api.get("/device").then((res) => res.data),

  // Get device by ID
  getDevice: (id) => api.get(`/device/${id}`).then((res) => res.data),

  // Get device history
  getDeviceHistory: (id) => {
    //unix datetime for the last 24 hours
    const start_date = Math.floor(Date.now() / 1000) - 86400;
    const end_date = Math.floor(Date.now() / 1000);

    return api.get(`/frame/${id}/${start_date}/${end_date}`).then((res) => {
      //sort history by time_created oldest to newest
      const dataSorted = res.data.sort((a, b) => {
        return new Date(a.time_created) - new Date(b.time_created);
      });
      return dataSorted;
    });
  },

  // Get devices by brand
  getDevicesByBrand: (brandId) =>
    api.get(`/device/brand/${brandId}`).then((res) => res.data),

  // Create device
  createDevice: (deviceData) => api.post("/device", deviceData),

  // Update device
  updateDevice: (id, deviceData) => api.put(`/device/${id}`, deviceData),

  // Change device ownership
  changeDeviceOwnership: (deviceId, ownershipData) =>
    api.put(`/device/${deviceId}/change_ownership`, ownershipData),

  // Delete device
  deleteDevice: (id) => api.delete(`/device/${id}`),

  // Get device brands
  getDeviceBrands: () => api.get("/device/brands").then((res) => res.data),
};
